@for (value of values; track $index; let i = $index) {
<div class="history-version-card">
    <div class="history-version-header">
        <hr class="h-2 bg-valamardarkgray rounded-xl w-[10rem]">
        <p class="whitespace-nowrap text-black">Verzija {{ value.version }}</p>
        <hr class="h-2 bg-valamardarkgray rounded-xl w-full">
    </div>

    <div class="history-meta-grid">
        <div>
            <b>Izmjena:</b><p class="ml-5 inline-block">{{ value.modifiedByUser }}</p>
        </div>
        <div>
            <b>Vrijeme izmjene:</b><p class="ml-5 inline-block">{{ value.modifiedDate | date: "dd.MM.yyyy., HH:mm:ss" }}</p>
        </div>
    </div>
    <div class="history-state-row">
        <div class="flex items-center">
            <b>Aktivan:</b><mat-icon class="ml-5">{{ value.isActive ? "check_box" : "check_box_outline_blank" }}</mat-icon>
        </div>
        <div class="flex items-center">
            <b>Skica:</b><mat-icon class="ml-5">{{ value.isDraft ? "check_box" : "check_box_outline_blank" }}</mat-icon>
        </div>
    </div>
    <div>
        <b>Naziv
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="valben-inline-select">
                <mat-select [(ngModel)]="nameLangs[i]">
                    @for (lang of value.names | objKeys; track lang) {
                        <mat-option [value]="lang">{{ lang }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>:</b>
        <p class="inline-block ml-5">{{ value.names[nameLangs[i]] }}</p>
    </div>
    <div>
        <b>Opis
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="valben-inline-select">
                <mat-select [(ngModel)]="descLangs[i]">
                    @for (lang of value.descriptions | objKeys; track lang) {
                        <mat-option [value]="lang">{{ lang }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>:</b>
        <p class="ml-5">{{ value.descriptions[descLangs[i]] | stripHtml }}</p>
    </div>
    <div>
        <b>Link slike:</b>
        @if (value.imageUrl) {
            <a href="{{ value.imageUrl }}" target="_blank" class="break-all ml-5 hover:text-valamarbluesecondary cursor-pointer">{{ value.imageUrl }}</a>
        } @else {
            <p class="inline-block ml-5">/</p>
        }

    </div>
    <div>
        <b>Kategorije:</b>
        <p class="ml-5 inline-block">{{ value.categoryIds | categoryNames }}</p>
    </div>
    <div>
        <b>Uključeni zaposlenici:</b>

        @if ((value.dependencies?.includedEmployees?.length ?? 0) > 0) {

            <button

                class="inline-block ml-5 valben-button"

                (click)="toggle(i, 0)">
                <mat-icon>{{ showDepends[i][0] ? "arrow_drop_down" : "arrow_right" }}</mat-icon>
            </button>

        } @else {

            <p class="inline-block ml-5">/</p>

        }

        @if (showDepends[i][0]) {

            <valben-virtual-listbox class="block w-fit" [items]="included[i]" />

        }

    </div>
    <div>
        <b>Isključeni zaposlenici:</b>
        @if ((value.dependencies?.excludedEmployees?.length ?? 0) > 0) {
            <button
                class="ml-5 valben-button"
                (click)="toggle(i, 1)">
                <mat-icon>{{ showDepends[i][1] ? "arrow_drop_down" : "arrow_right" }}</mat-icon>
            </button>
        } @else {
            <p class="inline-block ml-5">/</p>
        }
        @if (showDepends[i][1]) {
            <valben-virtual-listbox class="block w-fit" [items]="excluded[i]" />
        }
    </div>
    <div>
        <b>Filter grupe:</b>
        @if ((value.dependencies?.filterGroups?.length ?? 0) > 0) {
            <button
                class="ml-5 valben-button"
                (click)="toggle(i, 2)">
                <mat-icon>{{ showDepends[i][2] ? "arrow_drop_down" : "arrow_right" }}</mat-icon>
            </button>
        } @else {
            <p class="inline-block ml-5">/</p>
        }
        @if (showDepends[i][2]) {
            @for (group of value.dependencies?.filterGroups; track $index) {
            <div class="flex my-2 gap-4">
                @if (group.orgUnits && group.orgUnits.orgUnitIds.length > 0) {
                    <valben-virtual-listbox
                        title="Organizacijske jedinice"
                        [items]="group.orgUnits.orgUnitIds | orgUnitsNames" />
                }
                @if (group.costCenters && group.costCenters.costCenters.length > 0) {
                    <valben-virtual-listbox
                        title="Mjesta troška"
                        [items]="group.costCenters.costCenters | costCenterNames" />
                }
                @if (group.positions && group.positions.positions.length > 0) {
                    <valben-virtual-listbox
                        title="Pozicije"
                        [items]="group.positions.positions | positionsNames" />
                }
                @if (group.contracts && (group.contracts.types.length > 0 || group.contracts.subTypes.length > 0)) {
                    <valben-virtual-listbox
                        title="Ugovori"
                        [items]="group.contracts | contractNames" />
                }
                @if (group.genders && group.genders.length > 0) {
                    <valben-virtual-listbox
                        title="Spol"
                        [items]="group.genders" />
                }
            </div>
            }
        }
    </div>
</div>
}
